import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import './index.css'; // Import du fichier Tailwind CSS
import { setupErrorHandling } from './utils/errorHandler';

// Configuration du gestionnaire d'erreurs pour filtrer les erreurs d'extensions
setupErrorHandling();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
